import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const loginDevices = resourceReducer('loginDevices', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default loginDevices;

export const getLoginDevices = (state, page = 1) =>
  getResources(state, `fetchLoginDevices${page}`);
